import type { FormattedPresetNotify, INotifyQueue, Notify, YzcNotifyOption } from './types'

import { debugLog } from './debug'

export class YzcNotify {
  private notifyQueue: INotifyQueue

  private presetNotifyList: FormattedPresetNotify[] = []

  private waiting: boolean = false

  /**
   * @description
   * 是否已经执行过预置列表
   */
  private presetNotifyListFlushed: boolean = false

  /**
   * @description
   * 是否启用初始化
   */
  public _enableInit: boolean = true

  constructor(option: YzcNotifyOption, notifyQueue: INotifyQueue) {
    this.presetNotifyList = option.sort.map(s => ({
      ...s,
      registered: false,
      callback: undefined,
    }))
    this.notifyQueue = notifyQueue
  }

  /**
   * 注册弹窗方法，会在队列执行到注册的id位置时执行方法，一般是打开弹窗
   * @param id 唯一id
   * @param callback 弹窗对应的方法
   */
  registerShowEvent(id: Notify['id'], callback: Notify['callback']) {
    const notify: Notify = {
      id,
      callback,
    }
    const preset = this.presetNotifyList.find(n => n.id === notify.id)
    if (this.notifyQueue.getFlushing()) {
      // 正在执行 直接添加到队列中
      this.notifyQueue.addNotify(notify)
    }
    else {
      // 如果已经在预设顺序中
      if (preset) {
        // 注册
        preset.registered = true
        preset.callback = notify.callback
      }
      else {
        this.presetNotifyList.push({
          ...notify,
          registered: true,
        })
      }
      this.delayStart()
    }
  }

  /**
   * 执行下一个弹窗注册的方法
   */
  next() {
    debugLog('手动执行下一个通知', this.notifyQueue)
    this.notifyQueue.nextNotify()
  }

  private delayStart() {
    if (!this.waiting && this.presetNotifyListFlushed) {
      this.waiting = true
      globalThis.setTimeout(() => {
        this.addNotiesByPreset()
        this.notifyQueue.nextNotify()
        this.waiting = false
      }, 0)
    }
  }

  private addNotiesByPreset() {
    const registeredNotifies = this.presetNotifyList.filter(n => n.registered && n.callback)
    registeredNotifies.forEach((n) => {
      this.notifyQueue.addNotify(({
        id: n.id,
        callback: n.callback!,
      }))
      n.registered = false
    })
  }

  init() {
    if (!this.presetNotifyListFlushed && this._enableInit) {
      debugLog('初始化', '执行预设列表', this.presetNotifyList)
      this.presetNotifyListFlushed = true
      this.addNotiesByPreset()
      this.next()
    }
  }
}
